import { uiActions } from "./ui-slice";
import { searchActions } from "./search-slice";
import axios from "axios";
import { saveAs } from "file-saver";
import {jsonToCsv} from '../utils/utilsFunctions'
const baseUrl =
  process.env.REACT_APP_API_URL || "https://search.the-syllabus.com";
const projectIndex = process.env.REACT_APP_PROJECT_INDEX || "syllabus";
const isPrivate = Boolean(process.env.REACT_APP_IS_PRIVATE) || false;
const pageSize = Number(process.env.REACT_APP_PAGE_SIZE) || 30;

const menuIdMapping = {
  module: "modules",
  language: "languages",
  edition: "editions",
  contentType: "contentTypes",
};
const topicChannels = ["fes", "neolib", "climate"];
const menuLabelMapping = {
  module: topicChannels.includes(projectIndex) ? "topic" : "module",
  language: "language",
  edition: "edition",
  contentType: "Content Type",
};

export const fetchArticlesData = (searchParams, token) => {
  return async (dispatch) => {
    const headersObject = {
      "content-type": "application/json",
      //Authorization: cookies.tokenSearch
    };
    if (isPrivate) {
      headersObject.Authorization = `Bearer ${
        token ||
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ5dW51c2Jhcmxhc0BnbWFpbC5jb20iLCJleHAiOjE2OTU1NzEzOTl9.tLmpuNYdn40EAVq-AwP2qq2W9Xfh4uqp1wpwI4dZQK9FSfhI9pE3fj9fw661BVI6gb4KGLBvyuxup9z6q_li0A"
      }`;
    }
    // console.log('fetchArticlesData', searchParams);
    const fetchData = async () => {
      const response = await axios.post(
        `${baseUrl}/api/v1/${projectIndex}/search`,
        searchParams,
        { headers: headersObject }
      );

      if (response.status !== 200) {
        throw new Error("Something went wrong!");
      }
      const data = response.data;
      return data;
    };
    dispatch(searchActions.setLoader(true));
    try {
      const articlesData = await fetchData();
      dispatch(searchActions.setLoader(false));
      let maxPageNumber = 0;
      dispatch(searchActions.setTotalArticles(articlesData.totalResponseCount));
      if (articlesData.totalResponseCount % pageSize === 0) {
        maxPageNumber = articlesData.totalResponseCount / pageSize;
      } else {
        maxPageNumber = Math.trunc(articlesData.totalResponseCount / pageSize);
      }
      dispatch(searchActions.setMaxPage(maxPageNumber || 0));
      dispatch(searchActions.setLastFetchedPage(articlesData.pageNumber || 0));
      dispatch(
        searchActions.setArticles({
          articles: articlesData.searchDocuments || [],
        })
      );
    } catch (error) {
      dispatch(searchActions.setLoader(false));
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "Fetching cart data failed!",
        })
      );
    }
  };
};

export const getArticlesForDownload = (isCSV, searchParams, token) => {
  return async (dispatch) => {
    const headersObject = {
      "content-type": "application/json",
      //Authorization: cookies.tokenSearch
    };
    if (isPrivate) {
      headersObject.Authorization = `Bearer ${
        token ||
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ5dW51c2Jhcmxhc0BnbWFpbC5jb20iLCJleHAiOjE2OTU1NzEzOTl9.tLmpuNYdn40EAVq-AwP2qq2W9Xfh4uqp1wpwI4dZQK9FSfhI9pE3fj9fw661BVI6gb4KGLBvyuxup9z6q_li0A"
      }`;
    }

    const fetchData = async (pageN) => {
      const incrementedPageSize = {
        ...searchParams,
        pageSize: 1000,
        pageNumber: pageN || 0,
      };
      const response = await axios.post(
        `${baseUrl}/api/v1/${projectIndex}/search`,
        incrementedPageSize,
        { headers: headersObject }
      );

      if (response.status !== 200) {
        throw new Error("Something went wrong!");
      }
      const data = response.data;
      return data;
    };
    dispatch(searchActions.setDownloadLoader(true));
    try {
      const articlesData = await fetchData();
      const totalResponse = articlesData.totalResponseCount;
      const maxPages =
        totalResponse % 1000 === 0
          ? totalResponse / 1000
          : Math.trunc(totalResponse / 1000);
      // qui faccio la prima fetch
      async function waterfallCalls() {
        let result = [];

        let currentPage = 0;
        /*         while (currentPage <= maxPages) {
          console.log('here call at page n:', currentPage)
          currentPage++;
        }  */

        while (currentPage <= maxPages) {
          let res = await fetchData(currentPage);
          result = [...result, ...res.searchDocuments];
          dispatch(searchActions.setDownloadProgress(currentPage/maxPages *100));
          currentPage++;
        }
        let fileName = isCSV ? "theSyllabus_result.csv" : "theSyllabus_result.json";
        let csvFiletipe = isCSV ? 'text/csv' : 'application/json'
        let fileToSave = new Blob([isCSV ? jsonToCsv(result) : JSON.stringify(result)], {
          type: csvFiletipe,
        });
        // Save the file
        saveAs(fileToSave, fileName);
      }
      //
      await waterfallCalls();
      // set loader to false and reset downloadProgress to 0
      dispatch(searchActions.setDownloadLoader(false));
      dispatch(searchActions.setDownloadProgress(0));

    } catch (error) {
      dispatch(searchActions.setLoader(false));
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "Fetching cart data failed!",
        })
      );
    }
  };
};

/* export const getAllArticlesTest = () => {
  return async (dispatch) => {
    async function waterfallCalls() {
      let promises = [];
      let result = [];
    
      let currentPage = 0;
    
      while (currentPage <= 5) {
        promises.push(fakeApiCall(currentPage));
        currentPage++;
      }
    
      const data = await Promise.all(promises);
      data.forEach(({ data }) => {
        result = [...result, data];
      });
    

      // Do something with final result
    }
  };
}
 */
export const fetchAuthors = (author, token) => {
  return async (dispatch) => {
    const headersObject = {
      "content-type": "application/json",
      //Authorization: cookies.tokenSearch
    };
    if (isPrivate) {
      headersObject.Authorization = `Bearer ${
        token ||
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ5dW51c2Jhcmxhc0BnbWFpbC5jb20iLCJleHAiOjE2OTU1NzEzOTl9.tLmpuNYdn40EAVq-AwP2qq2W9Xfh4uqp1wpwI4dZQK9FSfhI9pE3fj9fw661BVI6gb4KGLBvyuxup9z6q_li0A"
      }`;
    }
    const fetchAuthorsData = async () => {
      const response = await axios.post(
        `${baseUrl}/api/v1/${projectIndex}/filterValues`,
        {
          attributeName: "author",
          query: author,
        },
        { headers: headersObject }
      );

      if (response.status !== 200) {
        throw new Error("Something went wrong!");
      }
      const data = response.data;
      return data;
    };
    dispatch(searchActions.setLoadingAuthors(true));
    try {
      const authorsData = await fetchAuthorsData();
      dispatch(searchActions.setLoadingAuthors(false));
      dispatch(searchActions.setAuthors(authorsData.filteredValues || []));
    } catch (error) {
      dispatch(searchActions.setLoadingAuthors(false));
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "Fetching cart data failed!",
        })
      );
    }
  };
};
export const fetchPublications = (publication, token) => {
  return async (dispatch) => {
    const headersObject = {
      "content-type": "application/json",
      //Authorization: cookies.tokenSearch
    };
    if (isPrivate) {
      headersObject.Authorization = `Bearer ${
        token ||
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ5dW51c2Jhcmxhc0BnbWFpbC5jb20iLCJleHAiOjE2OTU1NzEzOTl9.tLmpuNYdn40EAVq-AwP2qq2W9Xfh4uqp1wpwI4dZQK9FSfhI9pE3fj9fw661BVI6gb4KGLBvyuxup9z6q_li0A"
      }`;
    }
    const fetchPublicationsData = async () => {
      const response = await axios.post(
        `${baseUrl}/api/v1/${projectIndex}/filterValues`,
        {
          attributeName: "publication",
          query: publication,
        },
        { headers: headersObject }
      );

      if (response.status !== 200) {
        throw new Error("Something went wrong!");
      }
      const data = response.data;
      return data;
    };
    dispatch(searchActions.setLoadingPublications(true));
    try {
      const publicationsData = await fetchPublicationsData();
      const cleanAndSortPub = [
        ...new Set(publicationsData.filteredValues),
      ].sort();
      dispatch(searchActions.setLoadingPublications(false));
      dispatch(searchActions.setPublications(cleanAndSortPub || []));
    } catch (error) {
      dispatch(searchActions.setLoadingPublications(false));
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "Fetching cart data failed!",
        })
      );
    }
  };
};
export const fetchMenu = (token) => {
  return async (dispatch) => {
    const headersObject = {
      "content-type": "application/json",
      //Authorization: cookies.tokenSearch
    };
    if (isPrivate) {
      headersObject.Authorization = `Bearer ${
        token ||
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ5dW51c2Jhcmxhc0BnbWFpbC5jb20iLCJleHAiOjE2OTU1NzEzOTl9.tLmpuNYdn40EAVq-AwP2qq2W9Xfh4uqp1wpwI4dZQK9FSfhI9pE3fj9fw661BVI6gb4KGLBvyuxup9z6q_li0A"
      }`;
    }
    const fetchMenu = async () => {
      const response = await axios.post(
        `${baseUrl}/api/v1/${projectIndex}/menu`,
        { headers: headersObject }
      );

      if (response.status !== 200) {
        throw new Error("Something went wrong!");
      }
      const data = response.data;
      return data;
    };
    dispatch(searchActions.setLoadingMenu(true));
    try {
      const menuData = await fetchMenu();
      const arrayMenu = [];
      if (menuData.menu && Object.keys(menuData.menu).length) {
        Object.keys(menuData.menu).forEach((key) => {
          arrayMenu.push({
            id: menuIdMapping[key] ? menuIdMapping[key] : key,
            label: menuLabelMapping[key] ? menuLabelMapping[key] : key,
            values: menuData.menu[key].sort(),
          });
        });
      }
      dispatch(searchActions.setLoadingMenu(false));
      dispatch(searchActions.setMenu(arrayMenu || []));
    } catch (error) {
      dispatch(searchActions.setLoadingMenu(false));
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "Fetching cart data failed!",
        })
      );
    }
  };
};
export const resetAuthors = () => {
  return async (dispatch) => {
    dispatch(searchActions.setAuthors([]));
  };
};
export const resetPublications = () => {
  return async (dispatch) => {
    dispatch(searchActions.setPublications([]));
  };
};
export const setPage = (n) => {
  return async (dispatch) => {
    dispatch(searchActions.setPageNumber(n));
  };
};
export const setSearchQueries = (arrayOfQueries) => {
  return async (dispatch) => {
    dispatch(searchActions.setQueries(arrayOfQueries));
  };
};
export const setAdvanceSearchQuery = (obj) => {
  return async (dispatch) => {
    dispatch(searchActions.setAdvanceQuery(obj));
  };
};
export const setBookmarks = (list) => {
  return async (dispatch) => {
    dispatch(searchActions.setBookmarks(list))
  }
}
export const resetAdvancedQuery = () => {
  return async (dispatch) => {
    dispatch(searchActions.resetsetAdvanceQuery());
  };
};
